<template>
  <div :class="{ 'sk-loading': isLoading}">
    <div class="mt20">
      <spinner-three-bounce :displayNone="!isLoading"/>
      <div class="centerText " v-if="isLoading">
        <h3>
          Veuillez patienter pendant le chargement de vos données.
        </h3>
      </div>
    </div>

    <div v-if="!isLoading">
      <!-- Documents du véhicule avant la vente -->
      <Accordion title="Documents du véhicule avant la vente" titleIcon="fa fa-files-o" :expandedProp="false">
        <template slot="label">
          <label
              :class="{ 'label-danger': !beforeSaleDocumentsRequiredAndValid.length,
                        'label-warning': beforeSaleDocumentsRequiredAndValid.length && !beforeSaleDocumentsReady,
                        'label-primary': beforeSaleDocumentsReady }"
              class="label label-documents">
            {{ beforeSaleDocumentsRequiredAndValid.length }}/{{ beforeSaleDocumentsRequired.length }}
          </label>
        </template>
        <template slot="content">
          <div class="row">
            <component-document
                @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                :dataForValidationPopup="dataForValidationPopup"
                :command="command"
                :ownerInformation="ownerInformation"
                :futureOwner="futureOwner"
                v-for="(doc, key) in beforeSaleDocuments"
                :key="'beforeSaleDocuments_' + key"
                :document="doc"
                :required="beforeSaleDocumentsRequired.includes(doc)"
            />
          </div>
        </template>
      </Accordion>
      <!-- Fin des docs du véhicule avant la vente -->

      <!-- Documents du proprio actuel -->

      <Accordion title="Documents du propriétaire actuel" titleIcon="fa fa-files-o" :expandedProp="false">
        <template slot="label">
          <label
              :class="{ 'label-danger': !actualOwnerDocumentsRequiredAndValid.length,
                        'label-warning': actualOwnerDocumentsRequiredAndValid.length && !actualOwnerDocumentsReady,
                        'label-primary': actualOwnerDocumentsReady }"
              class="label label-documents">
            {{ actualOwnerDocumentsRequiredAndValid.length }}/{{ actualOwnerDocumentsRequired.length }}
          </label>
        </template>
        <template slot="content">
          <div class="row">
            <component-alert v-if="this.order == null||this.ownerInformation == null||this.ownerInformation.owners == null||this.ownerInformation.ownerQuestions == null"
                             type="danger"
                             label='Pour ne voir que les documents pertinents, veuillez compléter les sections "Propriétaire actuel" et "Futur propriétaire".'
            />
            <div class="col-lg-6">
              <div class="m-t-md">
                <h4>{{ actualOwnerTitle }}</h4>
              </div>
              <component-document
                  @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                  :dataForValidationPopup="dataForValidationPopup"
                  :command="command"
                  :ownerInformation="ownerInformation"
                  :futureOwner="futureOwner"
                  v-for="(doc, key) in actualOwnerDocuments.owner"
                  :key="'actualOwnerDocuments_owner_' + key"
                  :document="doc"
                  :subSection="true"
                  :required="actualOwnerDocumentsRequired.includes(doc)"
              />
              <div v-if="this.order == null||this.order[0].paymentMode == 2">
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in actualOwnerDocuments.kyc"
                    :key="'actualOwnerDocuments_kyc_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="actualOwnerDocumentsRequired.includes(doc)"
                />
              </div>
              <div class="m-t" v-if="this.order == null||this.order[0].paymentMode == 2">
                <div class="i-checks">
                  <label>
                    <input type="checkbox" checked="" value="" v-model="actualOwnerForeigner"><i></i>
                    <span class="font-bold">Résident hors U.E.</span>
                  </label>
                </div>
              </div>
              <div v-if="actualOwnerForeigner">
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in actualOwnerDocuments.foreigner"
                    :key="'actualOwnerDocuments_foreigner_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="actualOwnerDocumentsRequired.includes(doc)"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="this.ownerInformation == null||this.ownerInformation.owners == null||this.ownerInformation.owners.hasCoOwner" class="col-lg-6">
              <div class="m-t-md">
                <h4>Documents du cotitulaire</h4>
              </div>
              <component-document
                  @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                  :dataForValidationPopup="dataForValidationPopup"
                  :command="command"
                  :ownerInformation="ownerInformation"
                  :futureOwner="futureOwner"
                  v-for="(doc, key) in actualOwnerDocuments.coOwner"
                  :key="'actualOwnerDocuments_coOwner_' + key"
                  :document="doc"
                  :subSection="true"
                  :required="actualOwnerDocumentsRequired.includes(doc)"
              />
            </div>
            <div v-if="this.ownerInformation == null||this.ownerInformation.ownerQuestions == null||this.ownerInformation.ownerQuestions.isProfessional" class="col-lg-6">
              <div class="m-t-md">
                <h4>Documents professionnels</h4>
              </div>
              <component-document
                  @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                  :dataForValidationPopup="dataForValidationPopup"
                  :command="command"
                  :ownerInformation="ownerInformation"
                  :futureOwner="futureOwner"
                  v-for="(doc, key) in actualOwnerDocuments.pro"
                  :key="'actualOwnerDocuments_pro_' + key"
                  :document="doc"
                  :subSection="true"
                  :required="actualOwnerDocumentsRequired.includes(doc)"
              />
              <div class="m-t">
                <div class="i-checks">
                  <label>
                    <input type="checkbox" checked="" value="" v-model="onlineBank"><i></i>
                    <span class="font-bold">Banque en ligne</span>
                  </label>
                </div>
              </div>
              <div v-if="onlineBank">
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in actualOwnerDocuments.onlineBank"
                    :key="'actualOwnerDocuments_onlineBank_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="actualOwnerDocumentsRequired.includes(doc)"
                />
              </div>
            </div>
          </div>
        </template>
      </Accordion>
      <!-- Fin des documents du proprio actuel -->

      <!-- Documents du futur proprio -->
      <Accordion title="Documents du futur propriétaire" titleIcon="fa fa-files-o" :expandedProp="false">
        <template slot="label">
          <label
              :class="{ 'label-danger': !futureOwnerDocumentsRequiredAndValid.length,
                        'label-warning': futureOwnerDocumentsRequiredAndValid.length && !futureOwnerDocumentsReady,
                        'label-primary': futureOwnerDocumentsReady }"
              class="label label-documents">
            {{ futureOwnerDocumentsRequiredAndValid.length }}/{{ futureOwnerDocumentsRequired.length }}
          </label>
        </template>
        <template slot="content">
          <div class="row">
            <component-alert v-if="this.order == null||this.futureOwner == null"
                             type="danger"
                             label='Pour ne voir que les documents pertinents, veuillez compléter les sections "Propriétaire actuel" et "Futur propriétaire".'
            />
            <div class="col-lg-6">
              <div class="m-t-md">
                <h4>{{ futureOwnerTitle }}</h4>
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in futureOwnerDocuments.owner"
                    :key="'futureOwnerDocuments_owner_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="futureOwnerDocumentsRequired.includes(doc)"
                />
              </div>
              <div>
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in futureOwnerDocuments.kyc"
                    :key="'futureOwnerDocuments_kyc_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="futureOwnerDocumentsRequired.includes(doc)"
                />
              </div>
              <div class="m-t" v-if="this.order == null||this.order[0].paymentMode == 2">
                <div class="i-checks">
                  <label>
                    <input type="checkbox" checked="" value="" v-model="futureOwnerForeigner"><i></i>
                    <span class="font-bold">Résident hors U.E.</span>
                  </label>
                </div>
              </div>
              <div v-if="futureOwnerForeigner">
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in futureOwnerDocuments.foreigner"
                    :key="'futureOwnerDocuments_foreigner_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="futureOwnerDocumentsRequired.includes(doc)"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="m-t-md">
                <h4>Documents de l'acheteur</h4>
              </div>
              <component-document
                  @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                  :dataForValidationPopup="dataForValidationPopup"
                  :command="command"
                  :ownerInformation="ownerInformation"
                  :futureOwner="futureOwner"
                  v-for="(doc, key) in futureOwnerDocuments.buyer"
                  :key="'futureOwnerDocuments_buyer_' + key"
                  :document="doc"
                  :subSection="true"
                  :required="futureOwnerDocumentsRequired.includes(doc)"
              />
              <div>
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in futureOwnerDocuments.buyerKyc"
                    :key="'futureOwnerDocuments_buyerKyc_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="futureOwnerDocumentsRequired.includes(doc)"
                />
              </div>
              <div class="m-t" v-if="this.order == null||this.order[0].paymentMode == 2">
                <div class="i-checks">
                  <label>
                    <input type="checkbox" checked="" value="" v-model="buyerForeigner"><i></i>
                    <span class="font-bold">Résident hors U.E.</span>
                  </label>
                </div>
              </div>
              <div v-if="buyerForeigner">
                <component-document
                    @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                    :dataForValidationPopup="dataForValidationPopup"
                    :command="command"
                    :ownerInformation="ownerInformation"
                    :futureOwner="futureOwner"
                    v-for="(doc, key) in futureOwnerDocuments.buyerForeigner"
                    :key="'futureOwnerDocuments_buyerForeigner_' + key"
                    :document="doc"
                    :subSection="true"
                    :required="futureOwnerDocumentsRequired.includes(doc)"
                />
              </div>
            </div>
          </div>
        </template>
      </Accordion>
      <!-- Fin des documents du futur proprio -->

      <!-- Documents de la vente -->
      <Accordion title="Documents de la vente" titleIcon="fa fa-files-o" :expandedProp="true">
        <template slot="label">
          <label
              :class="{ 'label-danger': !saleDocumentsRequiredAndValid.length,
                        'label-warning': saleDocumentsRequiredAndValid.length && !saleDocumentsReady,
                        'label-primary': saleDocumentsReady }"
              class="label label-documents">
            {{ saleDocumentsRequiredAndValid.length }}/{{ saleDocumentsRequired.length }}
          </label>
        </template>
        <template slot="content">
          <div class="row">
            <component-generated-document
                :command="command"
                :dataForValidationPopup="dataForValidationPopup"
                v-for="(doc, key) in saleDocumentsToGenerate"
                :key="'saleDocumentsToGenerate_' + key"
                :document="doc"
                :required="saleDocumentsToGenerate.includes(doc)"
            />
            <div v-if="isB2c">
              <component-document
                  @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                  :dataForValidationPopup="dataForValidationPopup"
                  :command="command"
                  :ownerInformation="ownerInformation"
                  :futureOwner="futureOwner"
                  v-for="(doc, key) in saleDocumentsToUploadB2c"
                  :key="'saleDocumentsToUpload_' + key"
                  v-if="doc.canShow"
                  :document="doc"
                  :required="saleDocumentsToUploadB2c.includes(doc)"
              />
            </div>
            <div v-else>
              <component-document
                  @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                  :dataForValidationPopup="dataForValidationPopup"
                  :command="command"
                  :ownerInformation="ownerInformation"
                  :futureOwner="futureOwner"
                  v-for="(doc, key) in saleDocumentsToUpload"
                  :key="'saleDocumentsToUpload_' + key"
                  v-if="doc.canShow"
                  :document="doc"
                  :required="saleDocumentsToUpload.includes(doc)"
              />
            </div>
            <template v-if="saleDocumentsInfo.length">
              <component-document-simple v-for="(doc, key) in saleDocumentsInfo" :key="'saleDocumentsInfo_' + key" :document="doc" />
            </template>
          </div>
          <div class="row" v-if="this.order == null||this.order[0].paymentMode == 1">
            <component-document
                @updateCheckedValidDocumentsList="updateCheckedValidDocumentsList"
                :dataForValidationPopup="dataForValidationPopup"
                :command="command"
                :ownerInformation="ownerInformation"
                :futureOwner="futureOwner"
                v-for="(doc, key) in saleDocumentsToUploadBankCheck"
                :key="'saleDocumentsToUploadBankCheck_' + key"
                :document="doc"
                :required="saleDocumentsToUploadBankCheck.includes(doc)"
            />
          </div>
        </template>
      </Accordion>
      <!-- Fin des docs de la vente -->

      <!-- Documents d'après-vente -->
      <Accordion title="Documents d'après-vente" titleIcon="fa fa-files-o" :expandedProp="true" v-if="saleRdvDocuments.length">
        <template slot="label">
          <label class="label label-primary label-documents">
            {{ saleRdvDocuments.length }}
          </label>
        </template>
        <template slot="content">
          <div class="row">
            <template>
              <component-document-simple v-for="(doc, key) in saleRdvDocuments" :key="'saleRdvDocuments_' + key" :document="doc" />
            </template>
          </div>
        </template>
      </Accordion>
      <!-- Fin des docs d'après-vente -->

      <div class="row ibox">
        <div class="col-lg-12">
          <div class="pull-right">
            <button
                :disabled="checkedValidDocumentsList.length == 0"
                class="btn btn-success text-center"
                type="button"
                @click="downloadDocuments">
              <i class="fa fa-download"></i> Télécharger
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Document from '../../components/details/documents/Document.vue'
import GeneratedDocument from '../../components/details/documents/GeneratedDocuments.vue'
import SimpleDocument from '../../components/details/documents/SimpleDocument.vue'
import Alert from '../../components/Alert.vue'
import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
import Accordion from '@/components/accordion/accordion'

export default {
  props: {
    command: {
      type: Object,
      required: true
    }
  },

  components: {
    'component-document': Document,
    'component-generated-document': GeneratedDocument,
    'component-document-simple': SimpleDocument,
    'component-alert': Alert,
    SpinnerThreeBounce,
    Accordion
  },

  data: () => ({
    actualOwnerForeigner: false,
    futureOwnerForeigner: false,
    buyerForeigner: false,
    onlineBank: false,
    isLoading: true,
    checkedValidDocumentsList: [],
    dataForValidationPopup: null,
    procurationDocument: {
      url: "",
      base64: ""
    },
    beforeSaleDocuments: [
      {
        id: "",
        title: "Certificat d'immatriculation",
        code: "carRegistration",
        valid: false
      },
      {
        id: "",
        title: "Contre visite (optionnelle)",
        code: "consVisit",
        valid: false
      },
      {
        id: "",
        title: "Controle technique",
        code: "vehicleInspection",
        valid: false
      }
    ],
    saleDocumentsToGenerate: [
      {
        title: "Certificat de cession",
        query: 'generateCertifCession',
        base64: "",
        formIsCompleted: false,
        canGenerate: false
      },
      {
        title: "Bon de remise",
        query: 'generateDisposal',
        base64: "",
        canGenerate: false
      },
      {
        title: "Rapport d'inspection",
        query: 'generateExpertiseReport',
        base64: "",
        canGenerate: false
      },
      {
        title: "Mandat de carte grise",
        query: 'generateImmatMandat',
        base64: "",
        canGenerate: false,
      },
      {
        title: "Demande de certificat d'immatriculation",
        query: 'generateCertifImmat',
        base64: "",
        canGenerate: false,
      }
    ],
    saleDocumentsToUpload: [
      {
        id: "",
        title: "Bulletin de souscription - Garantie",
        code: "warrantyMecanique",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Certificat de situation administrative",
        code: "nonPedge",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de commande",
        code: "orderForm",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de commande signé",
        code: "orderFormSigned",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de livraison",
        code: "buyerDeliveryForm",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de livraison signé",
        code: "buyerDeliveryFormSigned",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Attestation d’achat",
        code: "purchaseCertificate",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Facture vendeur",
        code: "fee",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Facture de service acheteur",
        code: "deliveryAndFeeInvoice",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Attestation d’assurance",
        code: "insuranceCertificate",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Mandat vendeur - enregistrement cession",
        code: "sellerMandate",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Cerfa acheteur - changement de titulaire",
        code: "buyerCerfa",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Certificat de garantie",
        code: "warrantyCertificate",
        valid: false,
        canEdit: false,
        canShow: false
      },
      {
        id: "",
        title: "Contrat de garantie signé",
        code: "warrantyCertificateCarizy",
        valid: false,
        canEdit: false,
        canShow: false
      }
    ],
    saleDocumentsToUploadB2c: [
      {
        id: "",
        title: "Bulletin de souscription - Garantie",
        code: "warrantyMecanique",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Certificat de situation administrative",
        code: "nonPedge",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de commande",
        code: "orderForm",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de commande signé",
        code: "orderFormSigned",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de livraison",
        code: "buyerDeliveryForm",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Bon de livraison signé",
        code: "buyerDeliveryFormSigned",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Facture d'achat",
        code: "buyerInvoice",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Attestation d’assurance",
        code: "insuranceCertificate",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Mandat vendeur - enregistrement cession",
        code: "sellerMandate",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Cerfa acheteur - changement de titulaire",
        code: "buyerCerfa",
        valid: false,
        canEdit: true,
        canShow: true
      },
      {
        id: "",
        title: "Certificat de garantie",
        code: "warrantyCertificate",
        valid: false,
        canEdit: false,
        canShow: false
      },
      {
        id: "",
        title: "Contrat de garantie signé",
        code: "warrantyCertificateCarizy",
        valid: false,
        canEdit: false,
        canShow: false
      }
    ],
    saleDocumentsToUploadBankCheck: [
      {
        id: "",
        title: "Copie du chèque de banque",
        code: "bankCheck",
        valid: false
      },
    ],
    actualOwnerDocuments: {
      owner: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "owner"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "owner"
        },
        {
          id: "",
          title: "Procuration",
          code: "procuration",
          valid: false,
          user: "owner",
          info: "proc"
        }
      ],
      pro: [
        {
          id: "",
          title: "ID de tous les bénéficiaires",
          code: "beneficiaryId",
          valid: false,
          user: "owner",
          info: "idBenef"
        },
        {
          id: "",
          title: "KBIS",
          code: "companyRegistration",
          valid: false,
          user: "owner",
          info: "kbis"
        },
        {
          id: "",
          title: "Les status signés de la société",
          code: "companyStatus",
          valid: false,
          user: "owner"
        },
        {
          id: "",
          title: "Doc de composition du capital",
          code: "capitalComposition",
          valid: false,
          user: "owner",
          info: "capital"
        },
        {
          id: "",
          title: "RIB",
          code: "bankAccountIdentity",
          valid: false,
          user: "owner",
          info: "rib"
        },
        {
          id: "",
          title: "IBAN",
          code: "iban",
          valid: false,
          user: "owner",
          info: "iban"
        },
      ],
      seller: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "seller"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "seller"
        }
      ],
      coOwner: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "coOwner"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "coOwner"
        },
        {
          id: "",
          title: "Procuration",
          code: "procuration",
          valid: false,
          user: "coOwner",
          info: "proc"
        }
      ],
      kyc: [
        {
          id: "",
          title: "RIB",
          code: "bankAccountIdentity",
          valid: false,
          user: "owner"
        },
        {
          id: "",
          title: "2ème ID recto",
          code: "secondIdRecto",
          valid: false,
          user: "owner"
        },
        {
          id: "",
          title: "2ème ID verso",
          code: "secondIdVerso",
          valid: false,
          user: "owner"
        }
      ],
      foreigner: [
        {
          id: "",
          title: "Titre de séjour",
          code: "residencePermit",
          valid: false,
          user: "owner"
        }
      ],
      onlineBank: [
        {
          id: "",
          title: "ID supplémentaire",
          code: "additionalId",
          valid: false,
          user: "owner",
          info: "otherId"
        }
      ]
    },
    futureOwnerDocuments: {
      owner: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "futureOwner"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "futureOwner"
        },
        {
          id: "",
          title: "Procuration",
          code: "procuration",
          valid: false,
          user: "futureOwner",
          info: "proc"
        }
      ],
      kyc: [
        {
          id: "",
          title: "Justificatif de domicile",
          code: "proofOfAddress",
          valid: false,
          user: "futureOwner"
        }
      ],
      foreigner: [
        {
          id: "",
          title: "Titre de séjour",
          code: "residencePermit",
          valid: false,
          user: "futureOwner"
        }
      ],
      buyer: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "buyer"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "buyer"
        }
      ],
      buyerKyc: [
        {
          id: "",
          title: "RIB",
          code: "bankAccountIdentity",
          valid: false,
          user: "buyer"
        },
        {
          id: "",
          title: "Permis de conduite recto",
          code: "driverLicenceRecto",
          valid: false,
          user: "buyer"
        },
        {
          id: "",
          title: "Permis de conduite verso",
          code: "driverLicenceVerso",
          valid: false,
          user: "buyer"
        },
        {
          id: "",
          title: "Justificatif de domicile",
          code: "proofOfAddress",
          valid: false,
          user: "buyer"
        }
      ],
      buyerForeigner: [
        {
          id: "",
          title: "Titre de séjour",
          code: "residencePermit",
          valid: false,
          user: "buyer"
        }
      ],
    },
    saleRdvDocuments: [],
    futureOwner: null,
    ownerInformation: null,
    order: null,
  }),

  computed: {
    isB2c() {
      return this.command.ad.supplier !== 'carizy'
    },
    commandId () {
      return this.$route.params.id
    },

    futureOwnerTitle() {
      return "Documents du futur titulaire du certificat d’immatriculation " + ((this.futureOwner != null && this.futureOwner.isBuyerOwner) ? " et acheteur" : "");
    },

    actualOwnerTitle() {
      return "Documents du titulaire du certificat d’immatriculation " + ((this.ownerInformation != null && this.ownerInformation.owners !== null && this.ownerInformation.owners.isSellerOwner) ? " et vendeur" : "");
    },

    ownerInformationsQuery () {
      return gql`
        query{
          ownerInformation(orderId: "${this.commandId}") {
            owners {
              hasCoOwner
              isSellerOwner
              isSellerCoOwner
              owner {
                documentId
              }
              coOwner {
                documentId
              }
            }
            ownerQuestions {
              isProfessional
            }
          }
        }`
    },

    futureOwnerQuery() {
      return gql`
        query{
          futureOwner(orderId: "${this.commandId}") {
            isBuyerOwner
            owner {
              documentId
            }
          }
        }`
    },

    orderQuery() {
      return gql`
        query{
          order(id: "${this.commandId}") {
            paymentMode
            status {
              id
              label
            }
          }
        }`
    },

    isWarrantyPremium() {
      return this.command.options !== null ? ['16', '17', '20', '21'].includes(this.command.options[0].id) : false;
    },

    beforeSaleDocumentsRequiredAndValid() {
      const requiredAndValid = this.beforeSaleDocumentsRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    beforeSaleDocumentsRequired() {
      let required = this.beforeSaleDocuments.filter(function(item) {
        return (item.code !== "consVisit" && item.code !== "proofOfAddress")
      });

      if(!this.command.vehicule[0].over4years){
        let requiredStep2 = required.filter(function(item) {
          return item.code !== "vehicleInspection"
        });

        required = requiredStep2
      }
      return required
    },

    beforeSaleDocumentsReady() {
      if(this.beforeSaleDocumentsRequired.length - this.beforeSaleDocumentsRequiredAndValid.length === 0){
        return true
      } else {
        return false
      }
    },

    actualOwnerDocumentsOwnerRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsOwnerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsOwnerRequired() {
      const required = this.actualOwnerDocuments.owner.filter(function(item) {
        return (item.code !== "procuration" && item.code !== "proofOfAddress")
      });
      return required
    },

    actualOwnerDocumentsProRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsProRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsProRequired() {
      const required = this.actualOwnerDocuments.pro.filter(function(item) {
        return (item.code !== "capitalComposition" && item.code !== "proofOfAddress")
      });
      return required
    },

    actualOwnerDocumentsKycRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsKycRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsKycRequired() {
      const required = this.actualOwnerDocuments.kyc.filter(function(item) {
        return item.code !== "proofOfAddress"
      });
      return required
    },

    actualOwnerDocumentsSellerRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsSellerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsSellerRequired() {
      const required = this.actualOwnerDocuments.seller.filter(function(item) {
        return item.code !== "proofOfAddress"
      });
      return required
    },

    actualOwnerDocumentsCoOwnerRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsCoOwnerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsCoOwnerRequired() {
      const required = this.actualOwnerDocuments.coOwner.filter(function(item) {
        return (item.code !== "procuration" && item.code !== "proofOfAddress")
      });
      return required
    },

    actualOwnerDocumentsForeignerRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsForeignerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsForeignerRequired() {
      return this.actualOwnerDocuments.foreigner
    },

    actualOwnerDocumentsOnlineBankRequiredAndValid() {
      const requiredAndValid = this.actualOwnerDocumentsOnlineBankRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    actualOwnerDocumentsOnlineBankRequired() {
      return this.actualOwnerDocuments.onlineBank
    },

    actualOwnerDocumentsRequiredAndValid() {
      let result = this.actualOwnerDocumentsOwnerRequiredAndValid

      if(this.ownerInformation.ownerQuestions !== null && this.ownerInformation.ownerQuestions.isProfessional){
        result = result.concat(this.actualOwnerDocumentsProRequiredAndValid)
      }
      if (null !== this.ownerInformation.owners) {
        if(this.ownerInformation.owners.hasCoOwner){
          result = result.concat(this.actualOwnerDocumentsCoOwnerRequiredAndValid)
        }
        if(!this.ownerInformation.owners.isSellerOwner){
          result = result.concat(this.actualOwnerDocumentsSellerRequiredAndValid)
        }
      }
      if(this.actualOwnerForeigner){
        result = result.concat(this.actualOwnerDocumentsForeignerRequiredAndValid)
      }
      if(this.onlineBank){
        result = result.concat(this.actualOwnerDocumentsOnlineBankRequiredAndValid)
      }

      return result
    },

    actualOwnerDocumentsRequired() {
      let result = this.actualOwnerDocumentsOwnerRequired

      if(this.ownerInformation.ownerQuestions !== null && this.ownerInformation.ownerQuestions.isProfessional){
        result = result.concat(this.actualOwnerDocumentsProRequired)
      }
      if (null !== this.ownerInformation.owners) {
        if (this.ownerInformation.owners.hasCoOwner) {
          result = result.concat(this.actualOwnerDocumentsCoOwnerRequired)
        }
        if (!this.ownerInformation.owners.isSellerOwner) {
          result = result.concat(this.actualOwnerDocumentsSellerRequired)
        }
      }

      if(this.actualOwnerForeigner){
        result = result.concat(this.actualOwnerDocumentsForeignerRequired)
      }
      if(this.onlineBank){
        result = result.concat(this.actualOwnerDocumentsOnlineBankRequired)
      }
      return result
    },

    actualOwnerDocumentsReady() {
      if(this.actualOwnerDocumentsRequired.length - this.actualOwnerDocumentsRequiredAndValid.length === 0){
        return true
      } else {
        return false
      }
    },

    futureOwnerDocumentsOwnerRequiredAndValid() {
      const requiredAndValid = this.futureOwnerDocumentsOwnerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    futureOwnerDocumentsOwnerRequired() {
      const required = this.futureOwnerDocuments.owner.filter(function(item) {
        return (item.code !== "procuration" && item.code !== "proofOfAddress")
      });
      return required
    },

    futureOwnerDocumentsKycRequiredAndValid() {
      const requiredAndValid = this.futureOwnerDocumentsKycRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    futureOwnerDocumentsKycRequired() {
      const required = this.futureOwnerDocuments.kyc.filter(function(item) {
        return item.code !== "proofOfAddress"
      });
      return required
    },

    futureOwnerDocumentsForeignerRequiredAndValid() {
      const requiredAndValid = this.futureOwnerDocumentsForeignerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    futureOwnerDocumentsForeignerRequired() {
      return this.futureOwnerDocuments.foreigner
    },

    futureOwnerDocumentsBuyerRequiredAndValid() {
      const requiredAndValid = this.futureOwnerDocumentsBuyerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    futureOwnerDocumentsBuyerRequired() {
      const required = this.futureOwnerDocuments.buyer.filter(function(item) {
        return item.code !== "proofOfAddress"
      });
      return required
    },

    futureOwnerDocumentsBuyerKycRequiredAndValid() {
      const requiredAndValid = this.futureOwnerDocumentsBuyerKycRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    futureOwnerDocumentsBuyerKycRequired() {
      const required = this.futureOwnerDocuments.buyerKyc.filter(function(item) {
        return item.code !== "proofOfAddress"
      });
      return required
    },

    futureOwnerDocumentsBuyerForeignerRequiredAndValid() {
      const requiredAndValid = this.futureOwnerDocumentsBuyerForeignerRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    futureOwnerDocumentsBuyerForeignerRequired() {
      return this.futureOwnerDocuments.buyerForeigner
    },

    futureOwnerDocumentsRequiredAndValid() {
      let result = this.futureOwnerDocumentsOwnerRequiredAndValid

      if(this.futureOwnerForeigner){
        result = result.concat(this.futureOwnerDocumentsForeignerRequiredAndValid)
      }
      if(!this.futureOwner.isBuyerOwner){
        result = result.concat(this.futureOwnerDocumentsBuyerRequiredAndValid)
      }
      if(!this.futureOwner.isBuyerOwner && this.buyerForeigner){
        result = result.concat(this.futureOwnerDocumentsBuyerForeignerRequiredAndValid)
      }

      return result
    },

    futureOwnerDocumentsRequired() {
      let result = this.futureOwnerDocumentsOwnerRequired

      if(this.futureOwnerForeigner){
        result = result.concat(this.futureOwnerDocumentsForeignerRequired)
      }
      if(!this.futureOwner.isBuyerOwner){
        result = result.concat(this.futureOwnerDocumentsBuyerRequired)
      }
      if(!this.futureOwner.isBuyerOwner && this.buyerForeigner){
        result = result.concat(this.futureOwnerDocumentsBuyerForeignerRequired)
      }

      return result
    },

    futureOwnerDocumentsReady() {
      if(this.futureOwnerDocumentsRequired.length - this.futureOwnerDocumentsRequiredAndValid.length === 0){
        return true
      } else {
        return false
      }
    },

    saleDocumentsToUploadRequiredAndValid() {
      const requiredAndValid = this.saleDocumentsToUploadRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    saleDocumentsToUploadRequired() {
      let required = this.saleDocumentsToUpload

      if (!this.isWarrantyPremium) {
        let requiredStep2 = required.filter(function(item) {
          return item.code !== "warrantyMecanique"
        });

        required = requiredStep2
      }

      return required
    },

    saleDocumentsToUploadBankCheckRequiredAndValid() {
      const requiredAndValid = this.saleDocumentsToUploadBankCheckRequired.filter(function(item) {
        return item.valid
      });
      return requiredAndValid
    },

    saleDocumentsToUploadBankCheckRequired() {
      return this.saleDocumentsToUploadBankCheck
    },

    saleDocumentsToGenerateRequiredAndReady() {
      let requiredAndReady = []

      if(this.saleDocumentsToGenerate[0].canGenerate){
        requiredAndReady.push(this.saleDocumentsToGenerate[0])
      }

      if(this.saleDocumentsToGenerate[1].canGenerate){
        requiredAndReady.push(this.saleDocumentsToGenerate[1])
      }

      if(this.saleDocumentsToGenerate[2].canGenerate){
        requiredAndReady.push(this.saleDocumentsToGenerate[2])
      }

      if(this.saleDocumentsToGenerate[3].canGenerate){
        requiredAndReady.push(this.saleDocumentsToGenerate[3])
      }

      if(this.saleDocumentsToGenerate[4]){
        requiredAndReady.push(this.saleDocumentsToGenerate[4])
      }
      if(this.saleDocumentsToGenerate[5]){
        requiredAndReady.push(this.saleDocumentsToGenerate[5])
      }

      return requiredAndReady
    },

    saleDocumentsToGenerateRequired() {
      return this.saleDocumentsToGenerate
    },

    saleDocumentsRequiredAndValid() {
      let result = this.saleDocumentsToUploadRequiredAndValid.concat(this.saleDocumentsToGenerateRequiredAndReady);

      if(this.order[0].paymentMode == 1) {
        result = result.concat(this.saleDocumentsToUploadBankCheckRequiredAndValid)
      }

      return result
    },

    saleDocumentsRequired() {
      let result = this.saleDocumentsToUploadRequired.concat(this.saleDocumentsToGenerateRequired);

      if(this.order[0].paymentMode == 1) {
        result = result.concat(this.saleDocumentsToUploadBankCheckRequired)
      }

      return result
    },

    saleDocumentsReady() {
      return (this.saleDocumentsRequired.length - this.saleDocumentsRequiredAndValid.length === 0)
    },

    saleDocumentsInfo() {
      let saleDocumentsInfo = [];

      // if (this.isWarrantyPremium) {
      //   saleDocumentsInfo.push({
      //     code: "warrantyPremiumInfo",
      //     title: "Fiche d'information - Garantie",
      //     fileName: "InfoGarantie.pdf",
      //     url: "https://cdn.carizy.com/documents/FICHE_INFORMATION_Garantie_M_" + (this.command.realm === "carizy" ? "Carizy" : "SYC") + ".pdf"
      //   });
      // }

      return saleDocumentsInfo;
    }
  },

  mounted () {
    this.fetchProjectDocumentsQuery()
  },

  methods: {
    async fetchProjectDocumentsQuery () {
      // Company documents
      const resultForProjectDocument = await this.$apollo.query({
        query: gql`
                  query {
                   projectDocument(orderId: "${this.command.id}") {
                     carRegistration {
                        id
                        valid
                     }
                     consVisit {
                        id
                        valid
                     }
                     vehicleInspection {
                        id
                        valid
                     }
                     nonPedge {
                        id
                        valid
                     }
                     warrantyMecanique {
                        id
                        valid
                     }
                     bankCheck{
                        id
                        valid
                     }
                     salesMandate {
                        id
                        isYouSign
                        valid
                        name
                     }
                     orderForm {
                        id
                        isYouSign
                        valid
                        name
                     }
                     salesMandate {
                        id
                        isYouSign
                        valid
                        name
                     }
                     fee {
                        id
                        isYouSign
                        valid
                        name
                     }
                     purchaseCertificate {
                        id
                        isYouSign
                        valid
                        name
                     }
                     buyerInvoice {
                        id
                        isYouSign
                        valid
                        name
                     }
                     deliveryAndFeeInvoice {
                        id
                        isYouSign
                        valid
                        name
                     }
                     buyerDeliveryForm {
                        id
                        isYouSign
                        valid
                        name
                     }
                     buyerBuyCertificate {
                        id
                        isYouSign
                        valid
                        name
                     }
                     sellerInvoice {
                        id
                        isYouSign
                        valid
                        name
                     }
                     orderFormSigned {
                        id
                        isYouSign
                        valid
                        name
                     }
                     buyerDeliveryFormSigned {
                        id
                        isYouSign
                        valid
                        name
                     }
                     insuranceCertificate {
                        id
                        isYouSign
                        valid
                        name
                     }
                     sellerMandate {
                        id
                        isYouSign
                        valid
                        name
                     }
                     buyerCerfa {
                        id
                        isYouSign
                        valid
                        name
                     }
                     warrantyCertificate {
                        id
                        valid
                        name
                        canEdit
                        canShow
                     }
                     warrantyCertificateCarizy {
                        id
                        valid
                        name
                        canEdit
                        canShow
                     }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      // Before Sale
      if(resultForProjectDocument.data.projectDocument[0].carRegistration != null  && resultForProjectDocument.data.projectDocument[0].carRegistration.id){
        this.beforeSaleDocuments[0].id = resultForProjectDocument.data.projectDocument[0].carRegistration.id
        this.beforeSaleDocuments[0].valid = resultForProjectDocument.data.projectDocument[0].carRegistration.valid
      }
      if(resultForProjectDocument.data.projectDocument[0].consVisit != null && resultForProjectDocument.data.projectDocument[0].consVisit.id){
        this.beforeSaleDocuments[1].id = resultForProjectDocument.data.projectDocument[0].consVisit.id
        this.beforeSaleDocuments[1].valid = resultForProjectDocument.data.projectDocument[0].consVisit.valid
      }
      if(resultForProjectDocument.data.projectDocument[0].vehicleInspection != null && resultForProjectDocument.data.projectDocument[0].vehicleInspection.id){
        this.beforeSaleDocuments[2].id = resultForProjectDocument.data.projectDocument[0].vehicleInspection.id
        this.beforeSaleDocuments[2].valid = resultForProjectDocument.data.projectDocument[0].vehicleInspection.valid
      }

      // Sale Documents To Upload C2C
      if(resultForProjectDocument.data.projectDocument[0].warrantyMecanique != null && resultForProjectDocument.data.projectDocument[0].warrantyMecanique.id){
        this.saleDocumentsToUpload[0].id = resultForProjectDocument.data.projectDocument[0].warrantyMecanique.id
        this.saleDocumentsToUpload[0].valid = resultForProjectDocument.data.projectDocument[0].warrantyMecanique.valid
      }
      if(resultForProjectDocument.data.projectDocument[0].nonPedge != null && resultForProjectDocument.data.projectDocument[0].nonPedge.id){
        this.saleDocumentsToUpload[1].id = resultForProjectDocument.data.projectDocument[0].nonPedge.id
        this.saleDocumentsToUpload[1].valid = resultForProjectDocument.data.projectDocument[0].nonPedge.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].orderForm != null && resultForProjectDocument.data.projectDocument[0].orderForm.id){
        this.saleDocumentsToUpload[2].id = resultForProjectDocument.data.projectDocument[0].orderForm.id
        this.saleDocumentsToUpload[2].valid = resultForProjectDocument.data.projectDocument[0].orderForm.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].orderFormSigned != null && resultForProjectDocument.data.projectDocument[0].orderFormSigned.id){
        this.saleDocumentsToUpload[3].id = resultForProjectDocument.data.projectDocument[0].orderFormSigned.id
        this.saleDocumentsToUpload[3].valid = resultForProjectDocument.data.projectDocument[0].orderFormSigned.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm != null && resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm.id){
        this.saleDocumentsToUpload[4].id = resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm.id
        this.saleDocumentsToUpload[4].valid = resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned != null && resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned.id){
        this.saleDocumentsToUpload[5].id = resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned.id
        this.saleDocumentsToUpload[5].valid = resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].purchaseCertificate != null && resultForProjectDocument.data.projectDocument[0].purchaseCertificate.id){
        this.saleDocumentsToUpload[6].id = resultForProjectDocument.data.projectDocument[0].purchaseCertificate.id
        this.saleDocumentsToUpload[6].valid = resultForProjectDocument.data.projectDocument[0].purchaseCertificate.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].fee != null && resultForProjectDocument.data.projectDocument[0].fee.id){
        this.saleDocumentsToUpload[7].id = resultForProjectDocument.data.projectDocument[0].fee.id
        this.saleDocumentsToUpload[7].valid = resultForProjectDocument.data.projectDocument[0].fee.valid
      }
      if(resultForProjectDocument.data.projectDocument[0].deliveryAndFeeInvoice != null && resultForProjectDocument.data.projectDocument[0].deliveryAndFeeInvoice.id){
        this.saleDocumentsToUpload[8].id = resultForProjectDocument.data.projectDocument[0].deliveryAndFeeInvoice.id
        this.saleDocumentsToUpload[8].valid = resultForProjectDocument.data.projectDocument[0].deliveryAndFeeInvoice.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].insuranceCertificate != null && resultForProjectDocument.data.projectDocument[0].insuranceCertificate.id){
        this.saleDocumentsToUpload[9].id = resultForProjectDocument.data.projectDocument[0].insuranceCertificate.id
        this.saleDocumentsToUpload[9].valid = resultForProjectDocument.data.projectDocument[0].insuranceCertificate.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].sellerMandate != null && resultForProjectDocument.data.projectDocument[0].sellerMandate.id){
        this.saleDocumentsToUpload[10].id = resultForProjectDocument.data.projectDocument[0].sellerMandate.id
        this.saleDocumentsToUpload[10].valid = resultForProjectDocument.data.projectDocument[0].sellerMandate.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerCerfa != null && resultForProjectDocument.data.projectDocument[0].buyerCerfa.id){
        this.saleDocumentsToUpload[11].id = resultForProjectDocument.data.projectDocument[0].buyerCerfa.id
        this.saleDocumentsToUpload[11].valid = resultForProjectDocument.data.projectDocument[0].buyerCerfa.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].warrantyCertificate != null){
        this.saleDocumentsToUpload[12].id = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.id
        this.saleDocumentsToUpload[12].valid = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.valid
        this.saleDocumentsToUpload[12].canEdit = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.canEdit
        this.saleDocumentsToUpload[12].canShow = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.canShow
      }

      if(resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy != null){
        this.saleDocumentsToUpload[13].id = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.id
        this.saleDocumentsToUpload[13].valid = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.valid
        this.saleDocumentsToUpload[13].canEdit = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.canEdit
        this.saleDocumentsToUpload[13].canShow = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.canShow
      }


      // Sale Documents To Upload B2C

      if(resultForProjectDocument.data.projectDocument[0].warrantyMecanique != null && resultForProjectDocument.data.projectDocument[0].warrantyMecanique.id){
        this.saleDocumentsToUploadB2c[0].id = resultForProjectDocument.data.projectDocument[0].warrantyMecanique.id
        this.saleDocumentsToUploadB2c[0].valid = resultForProjectDocument.data.projectDocument[0].warrantyMecanique.valid
      }
      if(resultForProjectDocument.data.projectDocument[0].nonPedge != null && resultForProjectDocument.data.projectDocument[0].nonPedge.id){
        this.saleDocumentsToUploadB2c[1].id = resultForProjectDocument.data.projectDocument[0].nonPedge.id
        this.saleDocumentsToUploadB2c[1].valid = resultForProjectDocument.data.projectDocument[0].nonPedge.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].orderForm != null && resultForProjectDocument.data.projectDocument[0].orderForm.id){
        this.saleDocumentsToUploadB2c[2].id = resultForProjectDocument.data.projectDocument[0].orderForm.id
        this.saleDocumentsToUploadB2c[2].valid = resultForProjectDocument.data.projectDocument[0].orderForm.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].orderFormSigned != null && resultForProjectDocument.data.projectDocument[0].orderFormSigned.id){
        this.saleDocumentsToUploadB2c[3].id = resultForProjectDocument.data.projectDocument[0].orderFormSigned.id
        this.saleDocumentsToUploadB2c[3].valid = resultForProjectDocument.data.projectDocument[0].orderFormSigned.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm != null && resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm.id){
        this.saleDocumentsToUploadB2c[4].id = resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm.id
        this.saleDocumentsToUploadB2c[4].valid = resultForProjectDocument.data.projectDocument[0].buyerDeliveryForm.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned != null && resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned.id){
        this.saleDocumentsToUploadB2c[5].id = resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned.id
        this.saleDocumentsToUploadB2c[5].valid = resultForProjectDocument.data.projectDocument[0].buyerDeliveryFormSigned.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerInvoice != null && resultForProjectDocument.data.projectDocument[0].buyerInvoice.id){
        this.saleDocumentsToUploadB2c[6].id = resultForProjectDocument.data.projectDocument[0].buyerInvoice.id
        this.saleDocumentsToUploadB2c[6].valid = resultForProjectDocument.data.projectDocument[0].buyerInvoice.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].insuranceCertificate != null && resultForProjectDocument.data.projectDocument[0].insuranceCertificate.id){
        this.saleDocumentsToUploadB2c[7].id = resultForProjectDocument.data.projectDocument[0].insuranceCertificate.id
        this.saleDocumentsToUploadB2c[7].valid = resultForProjectDocument.data.projectDocument[0].insuranceCertificate.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].sellerMandate != null && resultForProjectDocument.data.projectDocument[0].sellerMandate.id){
        this.saleDocumentsToUploadB2c[8].id = resultForProjectDocument.data.projectDocument[0].sellerMandate.id
        this.saleDocumentsToUploadB2c[8].valid = resultForProjectDocument.data.projectDocument[0].sellerMandate.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].buyerCerfa != null && resultForProjectDocument.data.projectDocument[0].buyerCerfa.id){
        this.saleDocumentsToUploadB2c[9].id = resultForProjectDocument.data.projectDocument[0].buyerCerfa.id
        this.saleDocumentsToUploadB2c[9].valid = resultForProjectDocument.data.projectDocument[0].buyerCerfa.valid
      }

      if(resultForProjectDocument.data.projectDocument[0].warrantyCertificate != null){
        this.saleDocumentsToUploadB2c[10].id = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.id
        this.saleDocumentsToUploadB2c[10].valid = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.valid
        this.saleDocumentsToUploadB2c[10].canEdit = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.canEdit
        this.saleDocumentsToUploadB2c[10].canShow = resultForProjectDocument.data.projectDocument[0].warrantyCertificate.canShow
      }

      if(resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy != null){
        this.saleDocumentsToUploadB2c[11].id = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.id
        this.saleDocumentsToUploadB2c[11].valid = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.valid
        this.saleDocumentsToUploadB2c[11].canEdit = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.canEdit
        this.saleDocumentsToUploadB2c[11].canShow = resultForProjectDocument.data.projectDocument[0].warrantyCertificateCarizy.canShow
      }


      // Sale Documents To Upload Bank Check
      if(resultForProjectDocument.data.projectDocument[0].bankCheck != null && resultForProjectDocument.data.projectDocument[0].bankCheck.id){
        this.saleDocumentsToUploadBankCheck[0].id = resultForProjectDocument.data.projectDocument[0].bankCheck.id
        this.saleDocumentsToUploadBankCheck[0].valid = resultForProjectDocument.data.projectDocument[0].bankCheck.valid
      }

      // GET CAN GENERATE DOCUMENTS
      await this.getCanGenerateDocuments();

      // GET DATA FOR VALIDATION POPUP
      await this.getDataForValidationPopup();

      // GET CUSTOMER DOCUMENTS
      await this.fetchCustomerDocumentsQuery();

      // GET Sale RDV documents
      await this.fetchSaleRdvDocuments();

      $(document).trigger('vue-loaded')
    },
    async getCanGenerateDocuments () {
      // GET CAN GENERATE DOCUMENTS
      const resultCanGenerateDocuments = await this.$apollo.query({
        query: gql`
                  query {
                   canGenerateDocuments(orderId: "${this.command.id}") {
                      certifCession {
                        canGenerate
                      }
                      invoice {
                        canGenerate
                      }
                      disposal {
                        canGenerate
                      }
                      expertiseReport {
                        canGenerate
                      }
                      purchaseOrder {
                          canGenerate
                      }
                      certifImmat {
                        canGenerate
                      }
                       immatMandat {
                       canGenerate
                      }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      if(resultCanGenerateDocuments.data.canGenerateDocuments){
        this.saleDocumentsToGenerate[0].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.certifCession.canGenerate
        this.saleDocumentsToGenerate[1].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.invoice.canGenerate
        this.saleDocumentsToGenerate[2].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.disposal.canGenerate
        this.saleDocumentsToGenerate[3].canGenerate = resultCanGenerateDocuments.data.canGenerateDocuments.expertiseReport.canGenerate
      }

      if (resultCanGenerateDocuments.data.canGenerateDocuments.purchaseOrder.canGenerate) {
        this.saleDocumentsToGenerate.splice(2, 1)
      } else {
        this.saleDocumentsToGenerate.splice(4, 1)
      }
    },
    async getDataForValidationPopup () {
      // GET DATA FOR VALIDATION POPUP
      const resultDataForValidationPopup = await this.$apollo.query({
        query: gql`
                  query {
                   customersRelatedAnOrder(orderId: "${this.command.id}") {
                      seller {
                        id
                        civility
                        firstname
                        lastname
                        email
                        phone
                        address {
                          address
                          city
                          zipCode
                        }
                        organization
                      }
                      buyer {
                        id
                        civility
                        firstname
                        lastname
                        email
                        phone
                        address {
                          address
                          city
                          zipCode
                        }
                        organization
                      }
                      owner {
                        firstName
                        lastName
                        address {
                          address
                          city
                          zipCode
                        }
                        civility
                        documentId
                        phone
                        email
                      }
                      futureOwner {
                        firstName
                        lastName
                        address {
                          address
                          city
                          zipCode
                        }
                        civility
                        documentId
                        phone
                        email
                      }
                      coOwner {
                        firstName
                        lastName
                        address {
                          address
                          city
                          zipCode
                        }
                        civility
                        documentId
                        phone
                        email
                      }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      this.dataForValidationPopup = resultDataForValidationPopup.data.customersRelatedAnOrder
    },
    async fetchCustomerDocumentsQuery () {
      // GET PROCURATION DOCUMENT
      await this.getProcurationDocument()

      // GET SELLER DATA
      await this.getSellerData ()

      // GET ACTUAL OWNER DATA
      await this.getActualOwnerData ()

      // GET CO-OWNER DATA
      await this.getCoOwnerData ()

      // GET BUYER DATA
      await this.getBuyerData ()

      // GET FUTURE OWNER DATA
      await this.getFutureOwnerData ()

      this.isLoading = false
    },
    async getProcurationDocument () {
      // GET PROCURATION DOCUMENT
      const resultForProcurationDocument = await this.$apollo.query({
        query: gql`
                  query {
                   procurationDocument {
                      url
                      base64
                      extension
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      if(resultForProcurationDocument.data.procurationDocument != null && resultForProcurationDocument.data.procurationDocument.base64){
        this.procurationDocument.url = resultForProcurationDocument.data.procurationDocument.url
        this.procurationDocument.base64 = resultForProcurationDocument.data.procurationDocument.base64
      }
    },
    async getSellerData () {
      // GET SELLER DATA
      const idSeller = this.command.seller[0].id

      const resultForCustomerDocumentForSeller = await this.$apollo.query({
        query: gql`
                  query {
                   customerDocument(customerId: "${idSeller}") {
                     idCardRecto {
                        id
                        valid
                     }
                     idCardVerso {
                        id
                        valid
                     }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      // Actual Owner - Seller
      if(resultForCustomerDocumentForSeller.data.customerDocument[0].idCardRecto != null && resultForCustomerDocumentForSeller.data.customerDocument[0].idCardRecto.id){
        this.actualOwnerDocuments.seller[0].id = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardRecto.id
        this.actualOwnerDocuments.seller[0].valid = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardRecto.valid
        this.actualOwnerDocuments.owner[0].id = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardRecto.id
        this.actualOwnerDocuments.owner[0].valid = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardRecto.valid
      }
      if(resultForCustomerDocumentForSeller.data.customerDocument[0].idCardVerso != null && resultForCustomerDocumentForSeller.data.customerDocument[0].idCardVerso.id){
        this.actualOwnerDocuments.seller[1].id = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardVerso.id
        this.actualOwnerDocuments.seller[1].valid = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardVerso.valid
        this.actualOwnerDocuments.owner[1].id = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardVerso.id
        this.actualOwnerDocuments.owner[1].valid = resultForCustomerDocumentForSeller.data.customerDocument[0].idCardVerso.valid
      }
    },
    async getBuyerData () {
      // GET BUYER DATA
      const idBuyer = this.command.buyer[0].id

      const resultForCustomerDocumentForBuyer = await this.$apollo.query({
        query: gql`
                  query {
                   customerDocument(customerId: "${idBuyer}") {
                     idCardRecto {
                        id
                        valid
                     }
                     idCardVerso {
                        id
                        valid
                     }
                     bankAccountIdentity {
                        id
                        valid
                     }
                     proofOfAddress {
                        id
                        valid
                     }
                     driverLicenceRecto {
                        id
                        valid
                     }
                     driverLicenceVerso {
                        id
                        valid
                     }
                     residencePermit {
                        id
                        valid
                     }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      // Future Owner - Buyer
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardRecto != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardRecto.id){
        this.futureOwnerDocuments.buyer[0].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardRecto.id
        this.futureOwnerDocuments.buyer[0].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardRecto.valid
      }
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardVerso != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardVerso.id){
        this.futureOwnerDocuments.buyer[1].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardVerso.id
        this.futureOwnerDocuments.buyer[1].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].idCardVerso.valid
      }

      // Future Owner - Buyer - Kyc
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].bankAccountIdentity != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].bankAccountIdentity.id){
        this.futureOwnerDocuments.buyerKyc[0].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].bankAccountIdentity.id
        this.futureOwnerDocuments.buyerKyc[0].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].bankAccountIdentity.valid
      }
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceRecto != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceRecto.id){
        this.futureOwnerDocuments.buyerKyc[1].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceRecto.id
        this.futureOwnerDocuments.buyerKyc[1].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceRecto.valid
      }
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceVerso != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceVerso.id){
        this.futureOwnerDocuments.buyerKyc[2].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceVerso.id
        this.futureOwnerDocuments.buyerKyc[2].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].driverLicenceVerso.valid
      }
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].proofOfAddress != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].proofOfAddress.id){
        this.futureOwnerDocuments.buyerKyc[3].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].proofOfAddress.id
        this.futureOwnerDocuments.buyerKyc[3].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].proofOfAddress.valid
      }



      // Future Owner - Buyer - Foreigner
      if(resultForCustomerDocumentForBuyer.data.customerDocument[0].residencePermit != null && resultForCustomerDocumentForBuyer.data.customerDocument[0].residencePermit.id){
        this.futureOwnerDocuments.buyerForeigner[0].id = resultForCustomerDocumentForBuyer.data.customerDocument[0].residencePermit.id
        this.futureOwnerDocuments.buyerForeigner[0].valid = resultForCustomerDocumentForBuyer.data.customerDocument[0].residencePermit.valid
      }
    },
    async getActualOwnerData () {
      // GET ACTUAL OWNER DATA
      if (null === this.ownerInformation.owners) {
        return;
      }

      const idOwner = this.ownerInformation.owners.owner.documentId

      const resultForCustomerDocumentForOwner = await this.$apollo.query({
        query: gql`
                  query {
                   customerDocument(documentId: "${idOwner}") {
                     idCardRecto {
                        id
                        valid
                     }
                     idCardVerso {
                        id
                        valid
                     }
                     bankAccountIdentity {
                        id
                        valid
                     }
                     procuration {
                        id
                        valid
                     }
                     beneficiaryId {
                        id
                        valid
                     }
                     companyRegistration {
                        id
                        valid
                     }
                     companyStatus {
                        id
                        valid
                     }
                     capitalComposition {
                        id
                        valid
                     }
                     iban {
                        id
                        valid
                     }
                     proofOfAddress {
                        id
                        valid
                     }
                     secondIdRecto {
                        id
                        valid
                     }
                     secondIdVerso {
                        id
                        valid
                     }
                     residencePermit {
                        id
                        valid
                     }
                     additionalId {
                        id
                        valid
                     }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      // Actual Owner - Owner
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].idCardRecto != null && resultForCustomerDocumentForOwner.data.customerDocument[0].idCardRecto.id){
        this.actualOwnerDocuments.owner[0].id = resultForCustomerDocumentForOwner.data.customerDocument[0].idCardRecto.id
        this.actualOwnerDocuments.owner[0].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].idCardRecto.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].idCardVerso != null && resultForCustomerDocumentForOwner.data.customerDocument[0].idCardVerso.id){
        this.actualOwnerDocuments.owner[1].id = resultForCustomerDocumentForOwner.data.customerDocument[0].idCardVerso.id
        this.actualOwnerDocuments.owner[1].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].idCardVerso.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].procuration != null && resultForCustomerDocumentForOwner.data.customerDocument[0].procuration.id){
        this.actualOwnerDocuments.owner[2].id = resultForCustomerDocumentForOwner.data.customerDocument[0].procuration.id
        this.actualOwnerDocuments.owner[2].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].procuration.valid
      }

      // Actual Owner - Kyc
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity != null && resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity.id){
        this.actualOwnerDocuments.kyc[0].id = resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity.id
        this.actualOwnerDocuments.kyc[0].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdRecto != null && resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdRecto.id){
        this.actualOwnerDocuments.kyc[1].id = resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdRecto.id
        this.actualOwnerDocuments.kyc[1].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdRecto.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdVerso != null && resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdVerso.id){
        this.actualOwnerDocuments.kyc[2].id = resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdVerso.id
        this.actualOwnerDocuments.kyc[2].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].secondIdVerso.valid
      }

      // Actual Owner - Foreigner
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].residencePermit != null && resultForCustomerDocumentForOwner.data.customerDocument[0].residencePermit.id){
        this.actualOwnerDocuments.foreigner[0].id = resultForCustomerDocumentForOwner.data.customerDocument[0].residencePermit.id
        this.actualOwnerDocuments.foreigner[0].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].residencePermit.valid
      }

      // Actual Owner - onlineBank
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].additionalId != null && resultForCustomerDocumentForOwner.data.customerDocument[0].additionalId.id) {
        this.actualOwnerDocuments.onlineBank[0].id = resultForCustomerDocumentForOwner.data.customerDocument[0].additionalId.id
        this.actualOwnerDocuments.onlineBank[0].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].additionalId.valid
      }

      // Actual Owner - Pro
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].beneficiaryId != null && resultForCustomerDocumentForOwner.data.customerDocument[0].beneficiaryId.id){
        this.actualOwnerDocuments.pro[0].id = resultForCustomerDocumentForOwner.data.customerDocument[0].beneficiaryId.id
        this.actualOwnerDocuments.pro[0].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].beneficiaryId.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].companyRegistration != null && resultForCustomerDocumentForOwner.data.customerDocument[0].companyRegistration.id){
        this.actualOwnerDocuments.pro[1].id = resultForCustomerDocumentForOwner.data.customerDocument[0].companyRegistration.id
        this.actualOwnerDocuments.pro[1].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].companyRegistration.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].companyStatus != null && resultForCustomerDocumentForOwner.data.customerDocument[0].companyStatus.id){
        this.actualOwnerDocuments.pro[2].id = resultForCustomerDocumentForOwner.data.customerDocument[0].companyStatus.id
        this.actualOwnerDocuments.pro[2].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].companyStatus.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].capitalComposition != null && resultForCustomerDocumentForOwner.data.customerDocument[0].capitalComposition.id){
        this.actualOwnerDocuments.pro[3].id = resultForCustomerDocumentForOwner.data.customerDocument[0].capitalComposition.id
        this.actualOwnerDocuments.pro[3].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].capitalComposition.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity != null && resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity.id){
        this.actualOwnerDocuments.pro[4].id = resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity.id
        this.actualOwnerDocuments.pro[4].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].bankAccountIdentity.valid
      }
      if(resultForCustomerDocumentForOwner.data.customerDocument[0].iban != null && resultForCustomerDocumentForOwner.data.customerDocument[0].iban.id){
        this.actualOwnerDocuments.pro[5].id = resultForCustomerDocumentForOwner.data.customerDocument[0].iban.id
        this.actualOwnerDocuments.pro[5].valid = resultForCustomerDocumentForOwner.data.customerDocument[0].iban.valid
      }
    },
    async getCoOwnerData () {
      // GET CO-OWNER DATA
      if (null === this.ownerInformation.owners) {
        return;
      }

      const idCoOwner = this.ownerInformation.owners.coOwner.documentId

      const resultForCustomerDocumentForCoOwner = await this.$apollo.query({
        query: gql`
                  query {
                   customerDocument(documentId: "${idCoOwner}") {
                     idCardRecto {
                        id
                        valid
                     }
                     idCardVerso {
                        id
                        valid
                     }
                     procuration {
                        id
                        valid
                     }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      // Actual Owner - CoOwner
      if(resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardRecto != null && resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardRecto.id){
        this.actualOwnerDocuments.coOwner[0].id = resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardRecto.id
        this.actualOwnerDocuments.coOwner[0].valid = resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardRecto.valid
      }
      if(resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardVerso != null && resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardVerso.id){
        this.actualOwnerDocuments.coOwner[1].id = resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardVerso.id
        this.actualOwnerDocuments.coOwner[1].valid = resultForCustomerDocumentForCoOwner.data.customerDocument[0].idCardVerso.valid
      }
      if(resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration != null && resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration.id){
        this.actualOwnerDocuments.coOwner[2].id = resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration.id
        this.actualOwnerDocuments.coOwner[2].valid = resultForCustomerDocumentForCoOwner.data.customerDocument[0].procuration.valid
      }
    },
    async getFutureOwnerData () {
      // GET FUTURE OWNER DATA
      if (null === this.futureOwner.owner) {
        return;
      }

      const idFutureOwner = this.futureOwner.owner.documentId

      const resultForCustomerDocumentForFutureOwner = await this.$apollo.query({
        query: gql`
                  query {
                   customerDocument(documentId: "${idFutureOwner}") {
                     idCardRecto {
                        id
                        valid
                     }
                     idCardVerso {
                        id
                        valid
                     }
                     procuration {
                        id
                        valid
                     }
                     bankAccountIdentity {
                        id
                        valid
                     }
                     proofOfAddress {
                        id
                        valid
                     }
                     driverLicenceRecto {
                        id
                        valid
                     }
                     driverLicenceVerso {
                        id
                        valid
                     }
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      // Future Owner - Owner
      if(resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardRecto != null && resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardRecto.id){
        this.futureOwnerDocuments.owner[0].id = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardRecto.id
        this.futureOwnerDocuments.owner[0].valid = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardRecto.valid
      }
      if(resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardVerso != null && resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardVerso.id){
        this.futureOwnerDocuments.owner[1].id = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardVerso.id
        this.futureOwnerDocuments.owner[1].valid = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].idCardVerso.valid
      }
      if(resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration != null && resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration.id){
        this.futureOwnerDocuments.owner[2].id = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration.id
        this.futureOwnerDocuments.owner[2].valid = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].procuration.valid
      }

      // Future Owner - Kyc
      if(resultForCustomerDocumentForFutureOwner.data.customerDocument[0].proofOfAddress != null && resultForCustomerDocumentForFutureOwner.data.customerDocument[0].proofOfAddress.id){
        this.futureOwnerDocuments.kyc[0].id = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].proofOfAddress.id
        this.futureOwnerDocuments.kyc[0].valid = resultForCustomerDocumentForFutureOwner.data.customerDocument[0].proofOfAddress.valid
      }
    },
    async fetchSaleRdvDocuments() {
      const resultForSaleRdvDocuments = await this.$apollo.query({
        query: gql`
              query {
               saleRdvDocuments(orderId: "${this.commandId}") {
                title
                fileName
                url
               }
              }
            `,
        fetchPolicy: 'no-cache'
      });

      if (resultForSaleRdvDocuments.hasOwnProperty('data')
          && resultForSaleRdvDocuments.data.hasOwnProperty('saleRdvDocuments')
      ) {
        if (!this.hasOwnProperty('saleRdvDocumentsTranslations')) {
          this['saleRdvDocumentsTranslations'] = require('../../helpers/translations/saleRdvDocuments.json');
        }

        resultForSaleRdvDocuments.data.saleRdvDocuments.forEach(doc => {
          let document = Object.assign({}, doc);

          if (this.saleRdvDocumentsTranslations.hasOwnProperty(doc.title)) {
            document.title = this.saleRdvDocumentsTranslations[doc.title];
          }

          this.saleRdvDocuments.push(document);
        });
      }
    },
    getBase64Document (id) {
      const query = gql`
              query {
                showDocument(
                files: {
                  fileId: ${id}
                })
                {
                  files {
                    base64
                    id
                  }
                }
              }
            `;

      return this.$apollo.query({
        query: query
      })
    },
    updateCheckedValidDocumentsList(data){
      if(data.checked){
        this.checkedValidDocumentsList.push(data.id);
      } else {
        const index = this.checkedValidDocumentsList.indexOf(data.id);

        if (index > -1) {
          this.checkedValidDocumentsList.splice(index, 1);
        }
      }
    },
    async downloadDocuments () {
      let array = this.checkedValidDocumentsList
      let i
      for (i = 0; i < array.length; i++) {
        const response = await this.getBase64Document(array[i])
        const base64 = response.data.showDocument.files[0].base64

        this.downloadFileFromBase64(base64)
      }
    },
  },

  watch: {
  },

  apollo: {
    ownerInformation: {
      query() {
        return this.ownerInformationsQuery
      }
    },

    futureOwner: {
      query() {
        return this.futureOwnerQuery
      }
    },

    order: {
      query() {
        return this.orderQuery
      }
    }
  }
}
</script>
